/**
 * Learning Links Database
 * Maps learning topics (Excel, Python, SQL, ...) to curated course links on
 * the author's own sites only — never external/third-party sites.
 *
 * NOTE: exported as a plain ES module default export. The original snippet
 * had two problems fixed here without changing any data:
 *   1. It used the UMD module.exports/window.X pattern, which risks a
 *      double-export conflict inside CRA/webpack — switched to `export default`.
 *   2. Its browser-fallback branch called `window.open(link.url, "_blank")`
 *      at module-load time (a bug — it referenced an undefined `link`
 *      variable and would have run immediately on import). That call has
 *      been removed entirely; opening a link is a UI concern, not something
 *      a data file should do on load.
 *
 * ⚠️ Several URLs below still end in "..." exactly as provided — these look
 * like truncated placeholders, not complete links. Replace them with the
 * real destination URLs before deploying.
 */

const learningLinks = {
  excel: [
    {
      title: "Excel Basics",
      url: "https://freecoursehub.xyz/..."
    },
    {
      title: "Advanced Excel",
      url: "https://freecoursehub.xyz/..."
    },
    {
      title: "Pivot Table",
      url: "https://munendra5singh.github.io/ExcelSuperGuru/..."
    },
    {
      title: "Excel Formulas",
      url: "https://munendra5singh.github.io/ExcelSuperGuru/..."
    }
  ],

  python: [
    {
      title: "Python Basics",
      url: "https://freecoursehub.xyz/..."
    },
    {
      title: "Python Projects",
      url: "https://freecoursehub.xyz/..."
    }
  ],

  sql: [
    {
      title: "SQL Basics",
      url: "https://freecoursehub.xyz/..."
    },
    {
      title: "Advanced SQL",
      url: "https://freecoursehub.xyz/..."
    }
  ]
};

export default learningLinks;
